// fetch agreements from TermsCondition collections
// do checkbox validation
// pass agreement id, user id, account id, email id, company name, ip address
// backend => userAgreement collection entry + update Accepted flag in user collection
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getTerms, signAgreement } from 'store/actions/termsAndConditionsActions';
import Button from '@material-ui/core/Button';
import { AGREEMENT_TERMS_THEME } from './AgreementMuiTheme';
import Checkbox from '@material-ui/core/Checkbox';
import {
    MuiThemeProvider,
    withStyles,
    DialogTitle,
    DialogContentText,
    Dialog,
    DialogContent,
    DialogActions
} from '@material-ui/core';
import AgreementTermsStyle from './AgreementTermsStyle';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import cs from 'classnames';
import Auxiliary from 'hoc/Auxiliary';
import { DEFAULT_THEME } from 'theme/CommonTheme';
import { PRIMARY_BUTTON_THEME, SECONDARY_BUTTON_THEME } from 'components/UI/Button/ButtonMuiTheme';
import { signOut } from '@ttc/authenticator/lib/Authenticator';
import authenticationManager from '../../container/AuthenticationManager';

const AgreementTerms = (props) => {
    const [signedTermsAndConditions, setSignedTermsAndConditions] = useState({
        is_agreed: false
    });

    const { classes } = props;

    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        props.getTerms();
    }, []);

    useEffect(() => {
        setSignedTermsAndConditions({
            ...signedTermsAndConditions,
            id: props.loggedInUserTerms.id,
            user_id: props.loggedInUserTerms.user_id,
            user_name: props.loggedInUserTerms.user_name,
            email: props.loggedInUserTerms.email,
            account_id: props.loggedInUserTerms.account_id,
            account_name: props.loggedInUserAccountName
        });
    }, [props.loggedInUserTerms]);

    const inputHandler = (value) => {
        setSignedTermsAndConditions({
            ...signedTermsAndConditions,
            version_id: props.termsAndConditions.id,
            version: props.termsAndConditions.version,
            is_agreed: value,
            ip_address: props.userIpAddress,
            agreed_on: getDate()
        });
        if (value) {
            setErrorText(false);
        }
    };

    const getDate = () => {
        let date = new Date();
        return `${date.getDate()}-${
            date.getMonth() + 1
        }-${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
    };

    const [referenceNode, setReferenceNode] = useState();
    const [errorText, setErrorText] = useState(false);
    const [scrolledToBottom, setScrolledToBottom] = useState(true);

    const agreeTerms = () => {
        if (!signedTermsAndConditions.is_agreed) {
            setErrorText(true);
        } else {
            setErrorText(false);
        }
        props.signAgreement(signedTermsAndConditions);
    };

    const handleScroll = (event) => {
        const node = event.target;
        const bottom = Math.ceil(node.scrollHeight - node.scrollTop) - 20 <= node.clientHeight;
        if (bottom) {
            setScrolledToBottom(false);
        }
    };

    useEffect(() => {
        if (referenceNode) {
            return () => referenceNode.removeEventListener('scroll', handleScroll);
        }
    }, []);

    const paneDidMount = (node) => {
        if (node) {
            node.addEventListener('scroll', handleScroll);
            setReferenceNode(node);
        }
    };

    const logout = () => {
        signOut(authenticationManager);
    };

    const openDialog = () => {
        setShowPopup(true);
    };

    const closeDialog = () => {
        setShowPopup(false);
    };

    return (
        <Auxiliary>
            <MuiThemeProvider theme={AGREEMENT_TERMS_THEME}>
                <Paper className={classes.root} elevation={1}>
                    <Typography variant="h5" component="h3">
                        Terms of Use
                    </Typography>
                    <Typography variant="h6" component="h3">
                        Before Trimble Transportation will share your data on TrustCenter, your
                        authorization is required.
                    </Typography>

                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <div className={cs(classes.termsAlign)} ref={paneDidMount}>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: props.termsAndConditions.terms
                                    }}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} className={classes.helpText}>
                            <Typography variant={'caption'}>
                                You must scroll to the bottom of the page
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={classes.nameColor}>
                                <span>
                                    {signedTermsAndConditions.user_name}(
                                    {signedTermsAndConditions.account_name})
                                </span>
                            </div>
                            <div>
                                {!scrolledToBottom ? (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={() =>
                                                    inputHandler(
                                                        !signedTermsAndConditions.is_agreed
                                                    )
                                                }
                                                value={signedTermsAndConditions.is_agreed}
                                                id="is_agreed"
                                                name="is_agreed"
                                                color="primary"
                                                disabled={scrolledToBottom}
                                            />
                                        }
                                        label="I agree to these Terms and Conditions."
                                    />
                                ) : null}

                                {errorText ? (
                                    <Typography
                                        variant={'caption'}
                                        className={classes.errorTextAlign}
                                    >
                                        You cannot proceed until you agree to the Terms and
                                        Conditions.
                                    </Typography>
                                ) : null}
                            </div>
                        </Grid>
                    </Grid>
                    <div className={cs(classes.buttonAlign, 'row justify-content-end no-gutters')}>
                        <div className={classes.cancelButtonAlign}>
                            <MuiThemeProvider theme={SECONDARY_BUTTON_THEME}>
                                <Button
                                    // variant="contained"
                                    id={'terms-cancel'}
                                    color="primary"
                                    onClick={() => openDialog()}
                                >
                                    Cancel
                                </Button>
                            </MuiThemeProvider>
                        </div>
                        <div>
                            <MuiThemeProvider theme={PRIMARY_BUTTON_THEME}>
                                <Button
                                    id={'terms-continue'}
                                    variant="contained"
                                    color="primary"
                                    disabled={
                                        scrolledToBottom || !signedTermsAndConditions.is_agreed
                                    }
                                    onClick={() => agreeTerms()}
                                >
                                    Continue
                                </Button>
                            </MuiThemeProvider>
                        </div>
                    </div>
                </Paper>
            </MuiThemeProvider>
            <MuiThemeProvider theme={DEFAULT_THEME}>
                <Dialog
                    open={showPopup}
                    onClose={() => closeDialog()}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{'Cancel Agreement'}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to cancel? If yes, you will be logged out.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button id="rCancel" onClick={() => closeDialog()} color="primary">
                            NO
                        </Button>
                        <Button
                            id="rSave"
                            onClick={() => {
                                logout();
                            }}
                            color="primary"
                            autoFocus
                        >
                            YES
                        </Button>
                    </DialogActions>
                </Dialog>
            </MuiThemeProvider>
        </Auxiliary>
    );
};

const mapStateToProps = (state) => ({
    termsAndConditions: state.termsAndConditions.termsAndConditions,
    loggedInUserTerms: state.termsAndConditions.loggedInUserTerms,
    loggedInUserAccountName: state.termsAndConditions.loggedInUserAccountName,
    userIpAddress: state.termsAndConditions.userIpAddress
});

export default connect(mapStateToProps, { getTerms, signAgreement })(
    withStyles(AgreementTermsStyle)(AgreementTerms)
);
